// ** React Imports
import { useState, useEffect, SyntheticEvent, useRef } from 'react'

import appInfo from '../../../configs/app-info';

import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import Grid, { GridProps } from '@mui/material/Grid';
import { styled, useTheme } from '@mui/material/styles'
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import CircularProgress from '@mui/material/CircularProgress'
import FormLabel from '@mui/material/FormLabel'
import {
    CardActions,
    Divider,
    IconButton,
    InputAdornment,
    Radio,
    RadioGroup,
    Tooltip,
    Fab,
    FormControlLabel
} from '@mui/material'

import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel'

import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'

import { useNavigate } from "react-router-dom";
import { Controller, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'
import moment from 'moment'

import Icon from '../../../components/icon';
import MsiDatagridDynamic from '../../../components/custom/MsiDatagridDynamic';
import apiUrl from '../../../configs/constant';
import MsiDatagrid from '../../../components/custom/MsiDatagridAuto';


// Styled Grid component
const StyledGrid = styled(Grid)<GridProps>(({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
        order: -1,
        display: 'flex',
        justifyContent: 'center'
    }
}))

// Styled component for the image
const Img = styled('img')(({ theme }) => ({
    right: 0,
    bottom: 8,
    width: 100,
    position: 'absolute',
    [theme.breakpoints.down('sm')]: {
        width: 200,
        position: 'static'
    }
}))

export default function Index() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const user = userData.data
    const token = userData.token

    const navigate = useNavigate();
    const inputRef = useRef<HTMLInputElement>(null)
    const inputQtyRef = useRef<HTMLInputElement>(null)
    const inputHargaRef = useRef<HTMLInputElement>(null)

    // STATE
    const [tglAwal, setTglAwal] = useState<string>(moment().startOf('month').format('YYYY-MM-DD'))
    const [tglAkhir, setTglAkhir] = useState<string>(moment().endOf('month').format('YYYY-MM-DD'))

    const [nominalDiskon, setNominalDiskon] = useState<any>(0)

    const [sdcustClassId, setSdcustClassId] = useState<any>(null)
    const [namaCust, setNamaCust] = useState<any>(null)
    const [waCust, setWaCust] = useState<any>(null)

    interface RowDataDetail {
        mmbarang_id: any
        nama_barang: any
        qty: any
        harga_pricelist: any
        harga: any
        total: number
        diskon: number
    }

    const [rowsDataDetail, setRowsDataDetail] = useState<RowDataDetail[]>([])

    const [listDetailPenjualan, setListDetailPenjualan] = useState<any[]>([])
    const [listHistory, setListHistory] = useState<any[]>([])
    const [listProduct, setListProduct] = useState<any[]>([])
    const [listCustomer, setListCustomer] = useState<any[]>([])
    const [listJenis, setListJenis] = useState<any[]>([])
    const [listRekap, setListRekap] = useState<any[]>([])
    const [listMonitor, setListMonitor] = useState<any[]>([])

    const [searchTerm, setSearchTerm] = useState('')

    const [elementRow, setElementRow] = useState<any>(null)
    const [qty, setQty] = useState<any>(1)

    // dialog
    const [openDialogCustomer, setOpenDialogCustomer] = useState<boolean>(false)
    const [openDialogAddCustomer, setOpenDialogAddCustomer] = useState<boolean>(false)
    const [openDialogProduct, setOpenDialogProduct] = useState<boolean>(false)
    const [openDialogHistory, setOpenDialogHistory] = useState<boolean>(false)
    const [openDialogPenerimaan, setOpenDialogPenerimaan] = useState<boolean>(false)
    const [openDialogRekap, setOpenDialogRekap] = useState<boolean>(false)
    const [openDialogMonitor, setOpenDialogMonitor] = useState<boolean>(false)
    const [openDialogExport, setOpenDialogExport] = useState<boolean>(false)
    const [tglAwalExport, setTglAwalExport] = useState<string>(moment().startOf('month').format('YYYY-MM-DD'))
    const [tglAkhirExport, setTglAkhirExport] = useState<string>(moment().endOf('month').format('YYYY-MM-DD'))

    const [openDialogQty, setOpenDialogQty] = useState<boolean>(false)

    const [openDialog, setOpenDialog] = useState(false)
    const [selectedIndex, setSelectedIndex] = useState<number | null>(null)
    const [editHarga, setEditHarga] = useState<number>(0)

    const handleOpenDialog = (index: number) => {
        setSelectedIndex(index)
        setEditHarga(rowsDataDetail[index].harga)
        setOpenDialog(true)
    }

    const handleCloseDialog = () => {
        setOpenDialog(false)
        setSelectedIndex(null)
    }

    const handleSaveHarga = () => {
        if (selectedIndex === null) return

        const newRows = [...rowsDataDetail]
        newRows[selectedIndex].harga = editHarga
        newRows[selectedIndex].total = editHarga * newRows[selectedIndex].qty
        setRowsDataDetail(newRows)
        handleCloseDialog()
    }

    // handle dialog
    const handleOpenDialogCustomer = () => {
        getCustomer()
    }
    const handleCloseDialogCustomer = () => {
        setOpenDialogCustomer(false)
    }

    const handleOpenDialogAddCustomer = () => {
        setOpenDialogCustomer(false)
        setOpenDialogAddCustomer(true)

        setSdcustClassId(null)
        setWaCust(null)
        setNamaCust(null)
    }
    const handleCloseDialogAddCustomer = () => {
        setOpenDialogAddCustomer(false)
        setOpenDialogCustomer(true)
    }

    const handleOpenDialogProduct = () => {
        getProduct()
        setOpenDialogProduct(true)
    }
    const handleCloseDialogProduct = () => {
        setOpenDialogProduct(false)
    }

    const handleCloseDialogExport = () => {
        setOpenDialogExport(false)
    }
    const convertDate = (pdate: Date) => {
        const yyyy = pdate.getFullYear()
        let mm = pdate.getMonth() + 1 // Months start at 0!
        let dd = pdate.getDate()

        let sdd: string = dd.toString()
        let smm: string = mm.toString()

        if (dd < 10) sdd = '0' + dd
        if (mm < 10) smm = '0' + mm

        const formatted = sdd + '-' + smm + '-' + yyyy

        return formatted
    }

    useEffect(() => {
        inputRef.current?.focus()
        getJenis()
    }, [])

    const getJenis = () => {
        const url = apiUrl.apiUrl + '/sales/pos/kelas-customer'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListJenis(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const getHistoryTransaksi = () => {
        let url =
            apiUrl.apiUrl + '/sales/pos/history-transaksi'

        axios
            .get(url, {
                params: {
                    tgl_awal: tglAwal,
                    tgl_akhir: tglAkhir
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                const data = response.data.data
                setListHistory(data)
                setOpenDialogHistory(true)
            })
    }

    const getListDetailPenjualan = () => {
        let url =
            apiUrl.apiUrl + '/sales/pos/detail-penjualan'

        axios
            .get(url, {
                params: {
                    tgl_awal: tglAwal,
                    tgl_akhir: tglAkhir
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                const data = response.data.data
                setListDetailPenjualan(data)
                setOpenDialogHistory(true)
            })
    }

    const getProduct = () => {
        const url = apiUrl.apiUrl + '/sales/pos/list-product'
        axios
            .get(url, {
                params: { mmbarang_class_id: 12509000003 },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListProduct(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const getCustomer = () => {
        const url = apiUrl.apiUrl + '/sales/pos/list-customer'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListCustomer(data)
                    setOpenDialogCustomer(true)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const getCustomerById = (id: any) => {
        const url = apiUrl.apiUrl + '/sales/pos/list-customer'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    data.forEach((element: any) => {
                        if (element.id == id) {
                            setValue('sdcust_id', element.id)
                            setValue('nama', element.nama)
                            setValue('telp', element.wa)
                            setValue('group', element.Grup_Customer)
                        }
                    })
                    setListCustomer(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const rowClickCustomer = (e: any) => {
        const value = e.data
        setValue('sdcust_id', value.id)
        setValue('nama', value.nama)
        setValue('telp', value.wa)
        setValue('group', value.Grup_Customer)
        setValue('alamat', value.alamat)

        setOpenDialogCustomer(false)

        setTimeout(() => {
            inputRef.current?.focus()
        }, 0)
    }

    // ⬇️ Fokus setiap kali dialog terbuka
    useEffect(() => {
        if (openDialogQty) {
            const timer = setTimeout(() => {
                inputQtyRef.current?.focus()
                inputQtyRef.current?.select()
            }, 150) // kasih delay sedikit biar dialog sempat muncul
            return () => clearTimeout(timer)
        }
    }, [openDialogQty])

    const rowClickProduct = (item: any) => {
        const product = item.data
        setOpenDialogProduct(false)
        setElementRow(product)
        setOpenDialogQty(true) // ini cukup, fokusnya otomatis dari useEffect di atas
    }

    const btnExcel = {
        color: '#fff',
        backgroundColor: '#10ac84',
        m: 3,

        '&:hover': {
            backgroundColor: '#10ac84'
        }
    }

    interface FormInputs {
        group: any
        sdcust_id: any
        nama: string
        keterangan: string
        total: any
        alamat: string
        telp: any
        user_id: any
        detail: any
        diskon: any
        accakun_id: any
        mmgudang_id: any
        accmaster_pembayaran_id: any
        notes: string
        referensi: string
        tgl: any
    }

    const defaultValues = {
        keterangan: '',
        user_id: user.id,
        // accakun_id: 10101010,
        mmgudang_id: 12510000004,
        tgl: new Date().toISOString().split('T')[0]
        // group: 'UMUM',
        // nama: 'BAZAR POLDA',
        // sdcust_id: 7425030246,
        // ppn: 0,
        // telp: 0
    }

    // ** Hooks
    const {
        control,
        setValue,
        getValues,
        handleSubmit,
        reset,
        resetField,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    const onSubmit = (data: any) => {
        // console.log(data)
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin menyimpan data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Simpan'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/sales/pos/insert-pos-new'
                axios
                    .post(url, data, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    const id = response.data.data
                                    handlePrintDual(id)
                                    window.location.reload()
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    }

    const addCustomer = () => {
        setOpenDialogAddCustomer(false)

        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        const send = {
            syscabang_id: 1,
            sysdoctag_id: 13,
            sdcust_class_id: sdcustClassId,
            nama: namaCust,
            nama2: namaCust,
            alamat: '-',
            telp: waCust,
            wa: waCust,
            diskon: 0
        }

        const url = apiUrl.apiUrl + '/sales/customer/add'
        axios
            .post(url, send, {
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'success',
                        timer: 1000,
                        timerProgressBar: true,
                        willClose: () => {
                            const id = response.data.data
                            getCustomerById(id)
                        }
                    })
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
            .catch(error => {
                Swal.fire({
                    title: 'Pemberitahuan',
                    text: error.message,
                    icon: 'error'
                })
            })
    }

    const handleTable = (index: number, evnt: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = evnt.target
        const rows = [...rowsDataDetail]
        // Cast name to keyof RowDataDetail to satisfy TypeScript
        rows[index][name as keyof RowDataDetail] = value
        let total = 0
        total = rows[index].harga * rows[index].qty
        // if (rows[index].qty >= 10) {
        //     total = rows[index].harga * rows[index].qty
        // } else {
        //     total = rows[index].harga * rows[index].qty
        //     rows[index].diskon = 0
        // }
        rows[index].total = total
        setRowsDataDetail(rows)
    }

    const deleteTableRows = (index: any) => {
        const rows = [...rowsDataDetail]
        rows.splice(index, 1)
        setRowsDataDetail(rows)
    }

    setValue('detail', JSON.stringify(rowsDataDetail))

    function sum(accumulator: any, a: any) {
        return accumulator + a.total
    }

    function sumQty(accumulator: any, a: any) {
        return accumulator + Number(a.qty)
    }

    const sumBarang = rowsDataDetail.reduce(sum, 0)
    const sumQuantity = rowsDataDetail.reduce(sumQty, 0)
    let sumDiskon = 0
    if (sumQuantity >= 10) {
        sumDiskon = sumQuantity * nominalDiskon
    } else {
        sumDiskon = 0
    }

    setValue('total', sumBarang - sumDiskon)
    setValue('diskon', sumDiskon)

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 100,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Tooltip title='Print' placement='top'>
                        <Box>
                            <IconButton onClick={() => handlePrint(row.ID)}>
                                <Icon icon='mdi:printer' color='#909090' />
                            </IconButton>
                        </Box>
                    </Tooltip>
                    <Tooltip title='Preview' placement='top'>
                        <Box>
                            <IconButton onClick={() => handlePreview(row.ID)}>
                                <Icon icon='mdi:search' color='#909090' />
                            </IconButton>
                        </Box>
                    </Tooltip>
                </Box>
            )
        }
    ]

    const handlePrint = (id: any) => {
        // let url = apiUrl.apiUrl3 + '/invoice/nota-58-subsidi/' + id
        // window.open(url, '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=yes')
    }

    const handlePreview = (id: any) => {
        // let url = apiUrl.apiUrl3 + '/invoice/nota-pdf-subsidi/' + id
        // window.open(url, '_blank')
    }

    const handlePrintDual = (id: any) => {
        // let url = apiUrl.apiUrl3 + '/invoice/nota-58-2-subsidi/' + id
        // window.open(url, '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=yes')
    }

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            event.preventDefault() // Mencegah submit form bawaan
            handleCheck()
        }
    }

    const handleKeyDownQty = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            event.preventDefault() // Mencegah submit form bawaan
            addBarang(qty)
        }
    }

    const handleCheck = () => {
        const value = inputRef.current?.value
        listProduct.forEach(element => {
            if (element.id == value) {
                setElementRow(element)
                setOpenDialogQty(true)
            }
        })
        if (inputRef.current) {
            inputRef.current.value = ''
        }
    }

    const addBarang = (qty: any) => {
        const rowsInput = {
            mmbarang_id: elementRow.id,
            nama_barang: elementRow.nama_barang,
            qty: qty,
            harga_pricelist: elementRow.harga_pricelist,
            harga: elementRow.harga,
            total: qty * elementRow.harga,
            diskon: 0
        }

        setRowsDataDetail([...rowsDataDetail, rowsInput])
        setOpenDialogQty(false)
        setQty(1)

        setTimeout(() => {
            inputRef.current?.focus()
        }, 100)
    }

    const renderCart = () => {
        return (
            <Box sx={{ mt: 3, p: 2, border: '1px solid #ddd', borderRadius: 1, boxShadow: 1, backgroundColor: '#f9f9f9' }}>
                <Typography variant='h6' fontWeight='bold' gutterBottom>
                    Keranjang Belanja
                </Typography>
                {rowsDataDetail.length === 0 ? (
                    <Typography variant='body1' textAlign='center'>
                        Daftar belanja kosong.
                    </Typography>
                ) : (
                    rowsDataDetail.reverse().map((product, index) => (
                        <div className={'content-block dx-card'} style={{ borderRadius: 1, color: '#212121' }} key={index}>
                            <CardContent>
                                <Box display='flex' justifyContent='space-between' alignItems='center'>
                                    <Typography variant='body1' fontWeight='bold' gutterBottom>
                                        {product.nama_barang}
                                    </Typography>
                                    <IconButton color='error' onClick={() => deleteTableRows(index)}>
                                        <Icon icon='mdi:trash' fontSize={20} />
                                    </IconButton>
                                </Box>
                                <Box display='flex' justifyContent='space-between' alignItems='center'>
                                    <TextField
                                        label='Quantity'
                                        name='qty'
                                        type='number'
                                        onChange={(evnt: any) => {
                                            handleTable(index, evnt)
                                        }}
                                        value={product.qty}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                    <Typography variant='body1'>
                                        Harga : <b>Rp. {product.harga.toLocaleString('id-ID', { maximumFractionDigits: 2 })}</b>
                                        <IconButton color='primary' onClick={() => handleOpenDialog(index)}>
                                            <Icon icon='mdi:pencil' fontSize={20} />
                                        </IconButton>
                                    </Typography>

                                    <Typography variant='body1'>
                                        Total : &nbsp;
                                        <Typography variant='h6' component='span'>
                                            <b>Rp. {product.total.toLocaleString('id-ID', { maximumFractionDigits: 2 })}</b>
                                        </Typography>
                                    </Typography>
                                </Box>
                            </CardContent>
                        </div>
                    ))
                )}

                {rowsDataDetail.length === 0 ? (
                    ''
                ) : (
                    <Box display='flex' justifyContent='space-between' alignItems='flex-start'>
                        <Box>
                            <Typography variant='body1' sx={{ mr: 3 }} fontWeight='bold' gutterBottom>
                                TOTAL QTY : &nbsp;
                                <Typography variant='h6' component='span'>
                                    <b>{sumQuantity}</b>
                                </Typography>
                            </Typography>
                        </Box>
                        <Box>
                            <Typography variant='body1' sx={{ textAlign: 'end', mr: 3 }} fontWeight='bold' gutterBottom>
                                GRAND TOTAL : &nbsp;
                                <Typography variant='h6' component='span'>
                                    <b>Rp. {(sumBarang - sumDiskon).toLocaleString('id-ID', { maximumFractionDigits: 2 })}</b>
                                </Typography>
                            </Typography>
                        </Box>
                    </Box>
                )}
            </Box>
        )
    }

    return (
        <>
            <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start' }}>
                <Grid item xl={12} md={12} xs={12}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Button
                                sx={{ mb: 2 }}
                                variant='contained'
                                color='primary'
                                startIcon={<Icon icon='mdi:history' />}
                                onClick={getHistoryTransaksi}
                            >
                                History Transaksi
                            </Button>
                            <Button
                                sx={{ mb: 2 }}
                                variant='contained'
                                color='primary'
                                startIcon={<Icon icon='mdi:list-box' />}
                                onClick={getListDetailPenjualan}
                            >
                                Laporan Detail Penjualan
                            </Button>
                            <Button
                                sx={{ mb: 2 }}
                                variant='contained'
                                color='info'
                                startIcon={<Icon icon='mdi:list-box' />}
                                onClick={() => navigate('/system/pos/import')}
                            >
                                Import dari BigSeller
                            </Button>
                            <Button
                                sx={{ mb: 2 }}
                                variant='contained'
                                color='primary'
                                startIcon={<Icon icon='mdi:list-box' />}
                                onClick={() => setOpenDialogExport(true)}
                            >
                                Export ke BigSeller
                            </Button>
                        </Box>
                        <div className={'content-block dx-card'}>
                            <Box
                                sx={{
                                    width: '100%',
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                                    <CardHeader title='POS' />
                                </Box>
                            </Box>
                            <Divider sx={{ m: 0 }} />
                            <CardContent>
                                <Grid
                                    container
                                    spacing={3}
                                    sx={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        justifyContent: 'flex-start'
                                    }}
                                >
                                    <Grid item xs={12} sm={3}>
                                        <Button
                                            variant='contained'
                                            color='primary'
                                            startIcon={<Icon icon='mdi:user' />}
                                            onClick={handleOpenDialogCustomer}
                                        >
                                            Cari Customer
                                        </Button>
                                    </Grid>
                                    <Grid item xs={12} sm={9}></Grid>
                                    <Grid item xs={12} sm={4}>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='nama'
                                                control={control}
                                                rules={{ required: true }}
                                                render={({ field: { value, onChange } }) => (
                                                    <TextField
                                                        label='Nama Customer'
                                                        error={Boolean(errors.nama)}
                                                        onChange={onChange}
                                                        value={value}
                                                        InputLabelProps={{ shrink: true }}
                                                        disabled
                                                    />
                                                )}
                                            />
                                            {errors.nama && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='telp'
                                                control={control}
                                                rules={{ required: true }}
                                                render={({ field: { value, onChange } }) => (
                                                    <TextField
                                                        label='No. HP'
                                                        error={Boolean(errors.telp)}
                                                        onChange={onChange}
                                                        value={value}
                                                        InputLabelProps={{ shrink: true }}
                                                        disabled
                                                    />
                                                )}
                                            />
                                            {errors.telp && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='group'
                                                control={control}
                                                rules={{ required: true }}
                                                render={({ field: { value, onChange } }) => (
                                                    <TextField
                                                        label='Group'
                                                        error={Boolean(errors.group)}
                                                        onChange={onChange}
                                                        value={value}
                                                        InputLabelProps={{ shrink: true }}
                                                        disabled
                                                    />
                                                )}
                                            />
                                            {errors.group && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='notes'
                                                control={control}
                                                rules={{ required: true }}
                                                render={({ field: { value, onChange } }) => (
                                                    <TextField
                                                        label='Notes'
                                                        error={Boolean(errors.notes)}
                                                        onChange={onChange}
                                                        value={value}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                            {errors.notes && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='referensi'
                                                control={control}
                                                rules={{ required: true }}
                                                render={({ field: { value, onChange } }) => (
                                                    <TextField
                                                        label='Referensi'
                                                        error={Boolean(errors.referensi)}
                                                        onChange={onChange}
                                                        value={value}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                            {errors.referensi && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='tgl'
                                                control={control}
                                                rules={{ required: true }}
                                                render={({ field: { value, onChange } }) => (
                                                    <TextField
                                                        label='Tanggal'
                                                        type='date'
                                                        error={Boolean(errors.tgl)}
                                                        onChange={onChange}
                                                        value={value}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                            {errors.tgl && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <br />
                                <hr />
                                <br />
                                <Grid
                                    container
                                    spacing={3}
                                    sx={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        justifyContent: 'flex-start'
                                    }}
                                >
                                    <Grid item xs={12} sm={12}>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <Button
                                                disabled={getValues('sdcust_id') == undefined ? true : false}
                                                variant='contained'
                                                color='primary'
                                                startIcon={<Icon icon='mdi:cube' />}
                                                onClick={handleOpenDialogProduct}
                                                sx={{ mr: 5 }}
                                            >
                                                Pilih Barang
                                            </Button>
                                            <TextField
                                                autoFocus
                                                inputRef={inputRef}
                                                label='ID Barang'
                                                type='number'
                                                onChange={e => {
                                                    setWaCust(e.target.value)
                                                }}
                                                InputLabelProps={{ shrink: true }}
                                                onKeyDown={handleKeyDown}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        {renderCart()}
                                    </Grid>
                                </Grid>
                            </CardContent>
                            <Divider sx={{ m: 0 }} />
                            <CardActions sx={{ p: 3 }}>
                                <Grid
                                    container
                                    spacing={2}
                                    alignItems="center"
                                    justifyContent="center"
                                >
                                    <Grid item xs={12} sm={3}>
                                        <Button
                                            fullWidth
                                            size="large"
                                            type="submit"
                                            variant="contained"
                                            disabled={sumBarang === 0}
                                            onClick={() => setValue('accakun_id', 120000)}
                                        >
                                            BAYAR TUNAI
                                        </Button>
                                    </Grid>

                                    <Grid item xs={12} sm={3}>
                                        <Button
                                            fullWidth
                                            size="large"
                                            type="submit"
                                            variant="contained"
                                            disabled={sumBarang === 0}
                                            onClick={() => setValue('accakun_id', 120001)}
                                        >
                                            TRANSFER
                                        </Button>
                                    </Grid>

                                    <Grid item xs={12} sm={3}>
                                        <Button
                                            fullWidth
                                            size="large"
                                            type="submit"
                                            variant="contained"
                                            disabled={sumBarang === 0}
                                            onClick={() => setValue('accakun_id', 120002)}
                                        >
                                            TIKTOK
                                        </Button>
                                    </Grid>

                                    <Grid item xs={12} sm={3}>
                                        <Button
                                            fullWidth
                                            size="large"
                                            type="submit"
                                            variant="contained"
                                            disabled={sumBarang === 0}
                                            onClick={() => setValue('accakun_id', 120003)}
                                        >
                                            SHOPEE
                                        </Button>
                                    </Grid>
                                </Grid>
                            </CardActions>
                        </div>
                    </form>
                </Grid>
            </Grid>
            <Dialog
                maxWidth={'lg'}
                fullWidth={true}
                open={openDialogCustomer}
                onClose={handleCloseDialogCustomer}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title'>
                    <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                        LIST CUSTOMER
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Button
                        variant='contained'
                        color='primary'
                        startIcon={<Icon icon='mdi:plus' />}
                        onClick={handleOpenDialogAddCustomer}
                    >
                        Buat Customer
                    </Button>

                    <MsiDatagrid array={listCustomer} rowClick={rowClickCustomer} />
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button onClick={handleCloseDialogCustomer}>Close</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                maxWidth={'xs'}
                fullWidth={true}
                open={openDialogAddCustomer}
                onClose={handleCloseDialogAddCustomer}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title'>
                    <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                        BUAT CUSTOMER
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Grid
                        container
                        spacing={3}
                        sx={{
                            mt: 1,
                            display: 'flex',
                            flexWrap: 'wrap',
                            justifyContent: 'flex-start'
                        }}
                    >
                        <Grid item xs={12} sm={12}>
                            <FormControl fullWidth>
                                <InputLabel id='controlled-select-label'>Jenis Group</InputLabel>
                                <Select
                                    autoWidth
                                    label='Jenis Group'
                                    id='controlled-select'
                                    onChange={e => {
                                        setSdcustClassId(e.target.value)
                                    }}
                                    inputProps={{ shrink: true }}
                                    labelId='controlled-select-label'
                                >
                                    <MenuItem value='' disabled>
                                        <em>Pilih Jenis Group</em>
                                    </MenuItem>
                                    {listJenis.map((item, index) => (
                                        <MenuItem value={item.id} key={index}>
                                            {item.nama}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <FormControl fullWidth>
                                <TextField
                                    label='Nama'
                                    onChange={e => {
                                        setNamaCust(e.target.value)
                                    }}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={12}>
                            <FormControl fullWidth>
                                <TextField
                                    label='No. HP'
                                    type='number'
                                    onChange={e => {
                                        setWaCust(e.target.value)
                                    }}
                                    InputLabelProps={{ shrink: true }}
                                    placeholder='Contoh: 62811...'
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={12}>
                            <Button size='large' onClick={addCustomer} variant='contained'>
                                Simpan
                            </Button>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button onClick={handleCloseDialogAddCustomer}>Close</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                maxWidth={'sm'}
                fullWidth={true}
                open={openDialogExport}
                onClose={handleCloseDialogExport}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title'>
                    <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                        EXPORT KE BIGSELLER
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Grid
                        container
                        sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start' }}
                        spacing={3}
                    >
                        <Grid item xs={12} md={12}>
                            <FormControl fullWidth>
                                <TextField
                                    label='Tanggal Awal'
                                    type='date'
                                    onChange={(e) => setTglAwalExport(e.target.value)}
                                    value={tglAwalExport}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <FormControl fullWidth>

                                <TextField
                                    label='Tanggal Akhir'
                                    type='date'
                                    onChange={(e) => setTglAkhirExport(e.target.value)}
                                    value={tglAkhirExport}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <FormControl fullWidth>
                                <InputLabel id='controlled-select-label'>Jenis Export</InputLabel>
                                <Select
                                    autoWidth
                                    label='Jenis Export'
                                    id='controlled-select'
                                    onChange={e => {
                                    }}
                                    inputProps={{ shrink: true }}
                                    labelId='controlled-select-label'
                                >
                                    <MenuItem value='' disabled>
                                        <em>Pilih Jenis Export</em>
                                    </MenuItem>
                                    <MenuItem value={"stock-in"} key={1}>
                                        Stock In
                                    </MenuItem>
                                    <MenuItem value={"stock-out"} key={2}>
                                        Stock Out
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button onClick={handleCloseDialogExport} variant='contained' color='primary'>Close</Button>
                    <Button variant='contained'>
                        Download Export
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                maxWidth={'xl'}
                fullWidth={true}
                open={openDialogProduct}
                onClose={handleCloseDialogProduct}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title'>
                    <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                        LIST PRODUK
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ p: 1 }}>
                        <MsiDatagrid array={listProduct} rowClick={rowClickProduct} />
                    </Box>
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button onClick={handleCloseDialogProduct}>Close</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                maxWidth={'lg'}
                fullWidth={true}
                open={openDialogHistory}
                onClose={() => setOpenDialogHistory(false)}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title'>
                    <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                        HISTORY TRANSAKSI
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Grid
                        container
                        sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start', mt: 1 }}
                        spacing={3}
                    >
                        <Grid item xs={12} md={3}>
                            <FormControl fullWidth>
                                <TextField
                                    label='Tanggal Awal'
                                    type='date'
                                    onChange={(e) => setTglAwal(e.target.value)}
                                    value={tglAwal}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <FormControl fullWidth>

                                <TextField
                                    label='Tanggal Akhir'
                                    type='date'
                                    onChange={(e) => setTglAkhir(e.target.value)}
                                    value={tglAkhir}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <FormControl fullWidth>
                                <Button
                                    variant='contained'
                                    sx={{ mt: 1 }}
                                    startIcon={<Icon icon='mdi:magnify' />}
                                    onClick={getHistoryTransaksi}
                                >
                                    Cari Data
                                </Button>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <MsiDatagrid array={listHistory} actions={actionData} />
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button onClick={() => setOpenDialogHistory(false)}>Close</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                maxWidth={'xl'}
                fullWidth={true}
                open={openDialogPenerimaan}
                onClose={() => setOpenDialogPenerimaan(false)}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title'>
                    <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                        LIST DETAIL PENJUALAN
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Grid
                        container
                        sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start', mt: 1 }}
                        spacing={3}
                    >
                        <Grid item xs={12} md={3}>
                            <FormControl fullWidth>
                                <TextField
                                    label='Tanggal Awal'
                                    type='date'
                                    onChange={(e) => setTglAwal(e.target.value)}
                                    value={tglAwal}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <FormControl fullWidth>

                                <TextField
                                    label='Tanggal Akhir'
                                    type='date'
                                    onChange={(e) => setTglAkhir(e.target.value)}
                                    value={tglAkhir}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <FormControl fullWidth>
                                <Button
                                    variant='contained'
                                    sx={{ mt: 1 }}
                                    startIcon={<Icon icon='mdi:magnify' />}
                                    onClick={getListDetailPenjualan}
                                >
                                    Cari Data
                                </Button>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <MsiDatagrid array={listDetailPenjualan} />
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button onClick={() => setOpenDialogPenerimaan(false)}>Close</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                maxWidth={'lg'}
                fullWidth={true}
                open={openDialogRekap}
                onClose={() => setOpenDialogRekap(false)}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title'>
                    <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                        LIST REKAP PENJUALAN
                    </Typography>
                </DialogTitle>
                <Box
                    sx={{
                        width: '100%',
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        justifyContent: 'flex-end'
                    }}
                >
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mr: 5 }}>
                        <Button sx={btnExcel} variant='contained' color='primary' startIcon={<Icon icon='mdi:file-excel' />}>
                            Download EXCEL
                        </Button>
                    </Box>
                </Box>
                <DialogContent>
                    <MsiDatagrid array={listRekap} />
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button onClick={() => setOpenDialogRekap(false)}>Close</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                maxWidth={'lg'}
                fullWidth={true}
                open={openDialogMonitor}
                onClose={() => setOpenDialogMonitor(false)}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title'>
                    <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                        LIST MONITOR STOCK PENJUALAN
                    </Typography>
                </DialogTitle>
                <Box
                    sx={{
                        width: '100%',
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        justifyContent: 'flex-end'
                    }}
                >
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mr: 5 }}>
                        <Button sx={btnExcel} variant='contained' color='primary' startIcon={<Icon icon='mdi:file-excel' />}>
                            Download EXCEL
                        </Button>
                    </Box>
                </Box>
                <DialogContent>

                    <MsiDatagrid array={listMonitor} />
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button onClick={() => setOpenDialogMonitor(false)}>Close</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                maxWidth={'xs'}
                fullWidth={true}
                open={openDialogQty}
                onClose={() => setOpenDialogQty(false)}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title'>
                    <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                        MASUKKAN QUANTITY
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
                        <Grid item xl={12} md={12} xs={12}>
                            <Typography variant='body1' fontWeight='bold' gutterBottom sx={{ color: '#212121' }}>
                                Barang : {elementRow?.nama_barang}
                            </Typography>
                        </Grid>
                        <Grid item xl={12} md={12} xs={12}>
                            <TextField
                                fullWidth
                                label='Quantity'
                                name='qty'
                                type='number'
                                autoFocus
                                inputRef={inputQtyRef}
                                onChange={evnt => {
                                    setQty(evnt.target.value)
                                }}
                                defaultValue={qty}
                                InputLabelProps={{ shrink: true }}
                                onKeyDown={handleKeyDownQty}
                                inputProps={{ min: 1, max: 1000 }}
                            />
                        </Grid>
                        <Grid item xl={12} md={12} xs={12}>
                            <Button size='large' fullWidth onClick={() => addBarang(qty)} variant='contained'>
                                Simpan
                            </Button>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button onClick={() => setOpenDialogQty(false)}>Close</Button>
                </DialogActions>
            </Dialog>
            {/* === Dialog Edit Harga === */}
            <Dialog
                maxWidth={'xs'}
                fullWidth={true}
                open={openDialog}
                onClose={handleCloseDialog}
            >
                <DialogTitle>
                    <Typography variant='body1' sx={{ fontWeight: 500, my: 1.5, color: '#212121' }}>
                        Edit Harga Barang
                    </Typography>
                </DialogTitle>
                <DialogContent sx={{ pt: 2 }}>
                    <TextField
                        sx={{ my: 2 }}
                        fullWidth
                        label='Harga'
                        type='number'
                        value={editHarga}
                        autoFocus
                        onChange={e => setEditHarga(Number(e.target.value))}
                        InputLabelProps={{ shrink: true }}
                        onKeyDown={(e) => {
                            // cadangan: jika pengguna tekan Enter di field, submit juga
                            if (e.key === 'Enter') {
                                e.preventDefault()
                                handleSaveHarga()
                            }
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} color='inherit'>
                        Batal
                    </Button>
                    <Button onClick={handleSaveHarga} variant='contained' color='primary'>
                        Simpan
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}